var map = {
	"./caja-afa.gif": 6024,
	"./caja-afa.jpg": 7331,
	"./camara-con-foto-1.jpg": 9330,
	"./camara-con-foto-2.jpg": 8557,
	"./cartel-gracias-1.jpg": 9597,
	"./cartel-gracias.jpg": 4339,
	"./cartel-horarios-2.jpg": 1527,
	"./cartel-horarios-3.jpg": 362,
	"./cartel-horarios.jpg": 6914,
	"./chapa-perro-1.jpg": 8631,
	"./chapa-perro-2.jpg": 9960,
	"./chapa-perro-3.jpg": 3925,
	"./chapa-perro-4.jpg": 4686,
	"./huesito.jpg": 232,
	"./llavero-barbero.jpg": 8600,
	"./llavero-boca.jpg": 7940,
	"./llavero-buho.jpg": 7209,
	"./llavero-c++.jpeg": 1861,
	"./llavero-c-.gif": 7042,
	"./llavero-camara-frase.gif": 8245,
	"./llavero-camara-frase.jpg": 3154,
	"./llavero-ferretero.jpg": 3721,
	"./llavero-huracan.jpg": 5061,
	"./llavero-kali-2.jpg": 1265,
	"./llavero-kali.jpg": 2840,
	"./llavero-magento.gif": 7449,
	"./llavero-magento.jpg": 142,
	"./llavero-muela-2.jpg": 3178,
	"./llavero-muela.gif": 2624,
	"./llavero-muela.jpg": 3803,
	"./llavero-one-piece-1.jpg": 3918,
	"./llavero-one-piece-2.jpg": 5417,
	"./llavero-pelota-futbol.jpg": 8573,
	"./llavero-peluqueria-back.jpg": 5034,
	"./llavero-peluqueria-front.jpg": 4462,
	"./llavero-personalizado.jpg": 8140,
	"./llavero-pikachu.jpg": 2184,
	"./llavero-raqueta-tenis.jpg": 3620,
	"./llavero-react.gif": 1003,
	"./llavero-react.jpg": 6520,
	"./maceta-hombrecito.jpg": 2347,
	"./marca-pagina-moto-1.jpg": 5948,
	"./marca-pagina-moto-2.jpg": 7931,
	"./mushroom-mario-bros.jpg": 3737,
	"./pedido-personalizado.png": 1100,
	"./perchero-individual-2.jpg": 1816,
	"./perchero-individual.png": 4501,
	"./portada-portarretrato.png": 5136,
	"./portada-soporte-celular.png": 6980,
	"./portarretraro-back.jpg": 4812,
	"./portarretrato-front.jpg": 6734,
	"./portarretrato.jpg": 8940,
	"./raqueta-padel-1.jpg": 6255,
	"./raqueta-padel-2.jpg": 2640,
	"./raquetas-padel.jpg": 124,
	"./soporte-celular-san-lorenzo.jpg": 6677,
	"./soporte-celular.jpg": 9464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6025;